import { useTrackCommentModeToggledOff, useTrackCommentModeToggledOn } from '@air/analytics';
import { useCallback } from 'react';

import { useAnnotationV2Context } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';

export const useAnnotationsToggle = () => {
  const { isAnnotationsEnabled, setAnnotationsEnabled, setAnnotations } = useAnnotationV2Context();
  const { trackCommentModeToggledOff } = useTrackCommentModeToggledOff();
  const { trackCommentModeToggledOn } = useTrackCommentModeToggledOn();

  const showAnnotations = useCallback(() => {
    trackCommentModeToggledOn();
    setAnnotationsEnabled(true);
  }, [setAnnotationsEnabled, trackCommentModeToggledOn]);

  const hideAnnotations = useCallback(() => {
    trackCommentModeToggledOff();
    setAnnotationsEnabled(false);

    // Clear all in-progress annotations (same as FloatingCommentFormV2)
    setAnnotations([]);
  }, [setAnnotationsEnabled, trackCommentModeToggledOff, setAnnotations]);

  return {
    isAnnotationsEnabled,
    showAnnotations,
    hideAnnotations,
  };
};
